<template>
  <div id="aboutOuter" v-if="about">
    <div id="about" v-html="about.text"></div>
    <div id="notice" v-html="about.smalltext"></div>
  </div>
</template>

<script>
export default {
  computed: {
    about () {
      return this.$store.getters.about
    }
  },

  mounted () {
    this.$root.$emit('scrollAfterEnter')
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

#notice {
  font-size: $bodytype;
}

#aboutOuter {
  padding: 1.3rem $side calc(#{$menu} * 2);
}
</style>
